/*
    © 2021 EcomGraduates
*/

const initGeolocation = () => {
    fetch('https://ipapi.co/json')
        .then(response => response.json())
        .then(data => {
            console.log(data)
            if (window.geolocation.cart_currency === data.currency || !window.geolocation.enabled_currencies.includes(data.currency)) {
                return false
            }
            document.body.insertAdjacentHTML('beforeend', `
                <div id="modal-geolocation" class="modal fade" tabindex="-1" aria-labelledby="modal-geolocation-label" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 id="modal-geolocation-label" class="modal-title">
                                    ${window.geolocation.title.replace('[country]', data.country_name)}
                                </h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body text-center">
                                <img
                                    class="mt-1 mb-4 rounded"
                                    src="https://cdn.shopify.com/static/images/flags/${data.country_code.toLowerCase()}.svg"
                                    height="60"
                                    alt="">
                                <p class="mb-0">
                                    ${window.geolocation.description}
                                </p>
                            </div>
                            <div class="modal-footer">
                                <a
                                    class="btn btn-primary w-100 mb-0" 
                                    href="/?currency=${data.currency}">
                                        ${window.geolocation.button.replace('[currency]', data.currency)}
                                </a>
                                <button 
                                    class="btn btn-link w-100 btn-sm mb-0"
                                    data-bs-dismiss="modal">
                                    ${window.geolocation.dismiss}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            `)
            const modal = new bootstrap.Modal(document.querySelector('#modal-geolocation'))
            modal.show()
            window.localStorage.setItem('geolocation-set', true)
        })
}

setTimeout(() => {
    if (!window.localStorage.getItem('geolocation-set')) {
        initGeolocation()
    }
}, window.geolocation.delay * 1000)
